module.exports = __webpack_public_path__ + "img/SKWINKELNetActieEvaluatiesA1BD39.ea5cd384.png";